/** The team network page; the backend's connection-request emails link here. */
export const NETWORK_ROUTE = "/network";
